import React from "react";

function BillingAndSubscription() {
  return <div>BillingAndSubscription</div>;
}

export default BillingAndSubscription;
